export const REPORTS = {
  MM_VERIFICATION: {
    reportId: 100,
    reportName: 'Verification Report',
    reportKey: 'mm_verification_report',
  },
} as const;
